// Final ordered list of Odisha districts served by Jayatu Sanskrutam.
export const ODISHA_DISTRICTS = [
  "Puri",
  "Khordha",
  "Nayagarh",
  "Cuttack",
  "Jagatsinghpur",
  "Kendrapada",
  "Baleshwar",
  "Bhadrak",
  "Jajpur",
  "Mayurbhanj",
  "Kendujhar",
  "Dhenkanal",
  "Angul",
  "Ganjam",
  "Gajapati",
  "Kandhamal",
];
